import { SET_ERROR, HIDE_ERROR } from './errorActions';

const initState = {
  error: null,
  isOpen: false
};

export const errorReducer = function (state = initState, action) {
  const { error } = action;

  if (action.type === SET_ERROR && error) {
    return {
      error,
      isOpen: true
    };
  }
  if (action.type === HIDE_ERROR) {
    return {
      error: null,
      isOpen: false
    };
  }
  return state;
};
